import { render, staticRenderFns } from "./PostGalleryPreviewMobile.vue?vue&type=template&id=79f0b4e7&scoped=true"
import script from "./PostGalleryPreviewMobile.vue?vue&type=script&lang=ts"
export * from "./PostGalleryPreviewMobile.vue?vue&type=script&lang=ts"
import style0 from "./PostGalleryPreviewMobile.vue?vue&type=style&index=0&id=79f0b4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0b4e7",
  null
  
)

export default component.exports